import { useCallback, useContext } from 'react';

import { ModalsWrapperContext } from '@kanda-libs/ks-design-library';

import { MODAL_ID } from '../../constants';

interface SatNoteModalButtonHook {
  onClick: () => void;
}

export default function useSatNoteModalButton(): SatNoteModalButtonHook {
  const { showModal } = useContext(ModalsWrapperContext);

  const onClick = useCallback(() => {
    showModal(MODAL_ID);
  }, [showModal]);

  return {
    onClick,
  };
}
